import React from 'react'

export const columnDurationRenderer = (t) => ({ record }) => {
    const _value = record?.duration ?? 0
    let value = _value
    if((value + '').includes('.')) value = value.toFixed(1)

    return t("{{countofDays}} days", {countofDays: value})
}